/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import { InfoOutlined, QrCode } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Link,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  OutlinedInput,
  Paper,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import config from "../../../../../utils/config";
import {
  Encrypt,
  extractEthereumAddress,
  formatCryptoDecimals,
  formatNumber,
  getSymbol,
  isKycVerified,
  validator,
} from "../../../../../utils";
import { useDispatch, useSelector } from "react-redux";
import {
  getCurrenciesData,
  getDashboardData,
  getPayeeData,
  setLastRefId,
  showMessageBar,
} from "../../../../../store/actions";
import {
  ACTIVITY_DETAIL,
  ACTIVITY_META,
  ETH,
  EVENTS,
  MESSAGE_BAR_TYPES,
  WALLET_ADD_METHODS,
  paymentOptions,
} from "../../../../../utils/constants";
import {
  checkKyt,
  checkWithdraw,
  getFees,
  logEvent,
} from "../../../../../store/api";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { withdraw as WithdrawApi } from "../../../../../store/api";
import { styles } from "../../../theme";
import AppDialog from "../../../../../components/AppDialog";
import QrCodeScanner from "../../../../../components/QrCodeScanner";
import { openQrScanner } from "../../../../../utils/qrScanner";
import AppLoader from "../../../../../components/AppLoader";
import * as PropTypes from "prop-types";
import AppScreenLoader from "../../../../../components/AppScreenLoader";
import AppToolTip from "../../../../../components/AppTooltip";
import ConfirmAddressOwnership from "./ConfirmAddressOwnership";
import AppButton from "../../../../../components/AppButton";
import AppDialogHalfScreen from "../../../../../components/AppDialogHalfScreen";

export default function CryptoPayment({
  amount,
  setActive,
  active,
  setShowKytBlocked,
  setShowKyt,
}) {
  const { t } = useTranslation();
  const currencies = useSelector(({ currencies }) => currencies.currencies);
  const service = useSelector(({ dashboard }) => dashboard?.fiatService);
  const dispatch = useDispatch();
  const [feeStructure, setFeeStructure] = useState(null);
  const user = useSelector(({ Auth }) => Auth.user);
  const [address, setAddress] = useState("");
  const [withdrawEnabled, setWithdrawEnabled] = useState(false);
  const [cryptoCurrency, setCryptoCurrency] = useState(null);
  const [waitingText, setWatingText] = useState("");
  const [exchangeRate, setExchangeRate] = useState(0);
  const [qrcodeReader, setqrcodeReader] = useState(false);
  const [widthrawLoading, setWithdrawLoading] = useState(false);
  const [saveWallet, setSaveWallet] = useState(false);
  const [network, setNetwork] = useState("");
  const [currency, setCurrency] = useState("");
  const navigate = useNavigate();
  const [oldDataBeforeChange, setOldDataBeforeChange] = useState({});
  const [confirm, setConfirm] = useState(false);
  const symbols = useSelector(getSymbol);
  const account = useSelector(({ Auth }) => Auth.account);
  useEffect(() => {
    if(account?.payoutAccount?.configuration?.currency)
      setCurrency(account?.payoutAccount?.configuration?.currency)
      if(active === 3) {
        getFeesData();
      }
  }, [symbols, account, address, active])
  const [errors, setErrors] = useState({
    address: "",
    amount: "",
  });
  const [withdrawData, setWithdrawData] = useState({
    localPayoutAmount: 0,
    localProcessingFeeFiat: 0,
    localWithoutFeePayoutAmount: 0,
  });
  const location = useLocation();
  const [trackWalletEntry, setTrackWalletEntry] = useState(null);
  const ownershipFormData = useRef(null);
  useEffect(() => {
    dispatch(getCurrenciesData());
    dispatch(getPayeeData());
    dispatch(getDashboardData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (active === 2) {
      setWithdrawData({
        localPayoutAmount: 0,
        localProcessingFeeFiat: 0,
        localWithoutFeePayoutAmount: 0,
      });
      setExchangeRate(0);
      setAddress("");
      setFeeStructure(null);
    }
    if (active === 3 && !address) {
      setErrors({
        address: "",
        amount: "",
      })
      setSaveWallet(false);
      const localAddress = localStorage.getItem(
        `walletaddress-${cryptoCurrency}`
      );
      if (localAddress) {
        setAddress(localAddress);
        setSaveWallet(true);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active]);

  useEffect(() => {
    if (address && active === 3) {
      setTimeout(() => {
        validateAddress(address);
      }, 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address]);

  const handleManualAddressChange = (val) => {
    try {
      if (trackWalletEntry)
        clearTimeout(trackWalletEntry);
      if (val.target.value && address !== val.target.value) {
        //ignore if the same address is inputed
        const walletEntry = setTimeout(() => {
          logEvent({
            current: EVENTS.WITHDRAWAL.WALLET_ADD,
            activity: ACTIVITY_DETAIL.WITHDRAWAL.WALLET_ADD,
            meta: {
              data: {
                entry: WALLET_ADD_METHODS.MANUAL,
                pathname: location.pathname,
                source: ACTIVITY_META.WITHDRAWAL.WALLET_ADD,
              },
            },
          });
        }, 1000);
        setTrackWalletEntry(walletEntry);
      }
    } catch (err) {
      dispatch(showMessageBar(MESSAGE_BAR_TYPES.ERROR, err));
    } finally {
      handleAddressChange(val.target.value);
    }
  };
  const handleConfirmation = (show) => {
    setConfirm(show);
  };

  const handleAddressChange = (val) => {
    setAddress(val);
    setErrors({ address: "" });
    setWithdrawEnabled(false);
  };
  const setQrData = (text) => {
    if (cryptoCurrency === ETH) {
      text = extractEthereumAddress(text);
    }
    const validate = validator(text, cryptoCurrency);

    if (!validate) {
      dispatch(showMessageBar(MESSAGE_BAR_TYPES.ERROR, t('invalidAddress')));
      return;
    }
    logEvent({
      current: EVENTS.WITHDRAWAL.WALLET_ADD,
      activity: ACTIVITY_DETAIL.WITHDRAWAL.WALLET_ADD,
      meta: {
        data: {
          entry: WALLET_ADD_METHODS.CAMERA_SCAN,
          pathname: location.pathname,
          source: ACTIVITY_META.WITHDRAWAL.WALLET_ADD,
        },
      },
    });
    handleAddressChange(text);
    if (qrcodeReader) {
      setqrcodeReader(false);
    }
  };

  const getFeesData = async () => {
    try {
      const data = await getFees({
        amount,
        cryptoCurrency,
        cryptoNetwork: network,
      });
      setFeeStructure(data.result);
      setExchangeRate(data.result.cryptoCurrencyCurrentRate);
    } catch (err) {
      dispatch(showMessageBar(MESSAGE_BAR_TYPES.ERROR, err));
    }
  };

  const handleSaveWallet = (ev) => {
    logEvent({
      current: EVENTS.WITHDRAWAL.REMEMBER_WALLET,
      activity: ACTIVITY_DETAIL.WITHDRAWAL.REMEMBER_WALLET,
      meta: {
        data: {
          remember: ev.target.checked,
          pathname: location.pathname,
          source: ACTIVITY_META.WITHDRAWAL.REMEMBER_WALLET,
        },
      },
    });
    setSaveWallet(ev.target.checked);
  };
  const handleAddressInput = async () => {
    try {
      if (!address) {
        const text = await navigator?.clipboard?.readText();
        const validate = validator(text, cryptoCurrency);
        if (validate) {
          if (text && text !== address) {
            //ignore if the same address is inputed
            logEvent({
              current: EVENTS.WITHDRAWAL.WALLET_ADD,
              activity: ACTIVITY_DETAIL.WITHDRAWAL.WALLET_ADD,
              meta: {
                data: {
                  entry: WALLET_ADD_METHODS.MANUAL,
                  pathname: location.pathname,
                  source: ACTIVITY_META.WITHDRAWAL.WALLET_ADD,
                },
              },
            });
          }
          handleAddressChange(text);
        }
      }
    } catch (err) {
      // console.log(err);
    }
  };

  const handleCurrencySelect = (val) => {
    logEvent({
      current: EVENTS.WITHDRAWAL.CRYPTO_SELECTION,
      activity: ACTIVITY_DETAIL.WITHDRAWAL.CRYPTO_SELECTION,
      meta: {
        data: {
          crypto: val.currency,
          network: val.network,
          pathname: location.pathname,
          source: ACTIVITY_META.WITHDRAWAL.CRYPTO_SELECTION,
        },
      },
    });
    setCryptoCurrency(val.currency);
    setExchangeRate(val.payoutCurrency.currency.currentRate);
    setNetwork(val.network);
    setActive(active + 1);
  };
  const handleTransferChange = () => {
    setConfirm(false);
    setOldDataBeforeChange({ amount, currency, cryptoCurrency, address });
  };
  const isChangedData = () => {
    if (!oldDataBeforeChange.address) {
      return false;
    }
    return (
      Number(oldDataBeforeChange.amount) !== Number(amount) ||
      oldDataBeforeChange.currency !== currency ||
      oldDataBeforeChange.cryptoCurrency !== cryptoCurrency ||
      oldDataBeforeChange.address !== address
    );
  };
  const handleConfirm = async () => {
    setConfirm(false);
    await withdraw();
    logEvent({
      current: EVENTS.WITHDRAWAL.CONFIRM_CRYPTO_TRANSFER,
      activity: ACTIVITY_DETAIL.WITHDRAWAL.CONFIRM_CRYPTO_TRANSFER,
      meta: {
        data: {
          edit: isChangedData(),
          pathname: location.pathname,
          source: ACTIVITY_META.WITHDRAWAL.CONFIRM_CRYPTO_TRANSFER,
        },
      },
    });
  };
  const getLogo = (currency) => {
    return `${config.S3_GYL_ICONS}/${currency.toLowerCase()}.svg`;
  };
  const validateAddress = async (address, flag = false) => {
    try {
      setErrors({ address: "" });
      const validate = validator(address, cryptoCurrency);
      setWatingText(t("CheckingWallet"));
      if (validate) {
        try {
          await checkKyt({
            walletAddress: address,
            currency: cryptoCurrency,
          });
          const enc = JSON.stringify({
            amount,
            currency,
            cryptoCurrency,
            walletAddress: address,
            cryptoNetwork: network,
          });
          const payload = {
            encryptedReq: Encrypt(enc),
          };
          if (!flag) {
            const data = await checkWithdraw(payload);
            setWithdrawData(data.result);
            setExchangeRate(data.result.cryptoCurrencyCurrentRate);
          }
          setWatingText("");
          setWithdrawEnabled(true);
          return true;
        } catch (err) {
          setWatingText("");
          setWithdrawEnabled(false);
          setErrors({ address: err?.response?.data?.message || err.message });
          return false;
        }
      } else if (address.length) {
        setErrors({ address: t("invalidAddress") });
        setWatingText("");
        setWithdrawEnabled(false);
        return false;
      } else if (!address.length) {
        setWithdrawEnabled(false);
        setWatingText("");
        return false;
      }
    } catch (err) {
      setWithdrawEnabled(false);
      setWatingText("");
      if (qrcodeReader) {
        setqrcodeReader(false);
      }
      return false;
    }
  };
  const withdraw = async () => {
    try {
      if (!address) {
        setWithdrawEnabled(false);
      }
      setWithdrawLoading(true);
      if (!(await validateAddress(address, true))) {
        return;
      }
      if (validateWithdraw()) {
        // execute withdraw
        setWatingText("Initiating Transfer Request ... ");
        const enc = JSON.stringify({
          amount,
          cryptoCurrency,
          walletAddress: address,
          cryptoNetwork: network,
          recordId: withdrawData?.recordId,
          ownershipInfo: ownershipFormData.current
        });
        const payload = {
          encryptedReq: Encrypt(enc),
        };

        const data = await WithdrawApi(payload);
        setWatingText("");
        setWithdrawLoading(false);
        if (data?.result?.error) {
          if (data?.result?.isTravelRuleReject) {
            navigate(`/withdraw/status/undefined?isTravelRuleReject=1`);
            return;
          }
          dispatch(
            showMessageBar(MESSAGE_BAR_TYPES.ERROR, data?.result?.message)
          );
        } else {
          dispatch(setLastRefId(data.result.id));
          if (saveWallet)
            localStorage.setItem(`walletaddress-${cryptoCurrency}`, address);
          else localStorage.removeItem(`walletaddress-${cryptoCurrency}`);
          navigate(`/withdraw/status/${data.result.id}`);
          logEvent({
            current: EVENTS.WITHDRAWAL.INITIATE_TRANSFER,
            activity: ACTIVITY_DETAIL.WITHDRAWAL.INITIATE_TRANSFER,
            meta: {
              data: {
                currencyType: cryptoCurrency
                  ? paymentOptions.crypto
                  : paymentOptions.fiat,
                currency: cryptoCurrency ? cryptoCurrency : currency,
                pathname: location.pathname,
                source: ACTIVITY_META.WITHDRAWAL.INITIATE_TRANSFER,
              },
            },
          });
        }
      }
    } catch (err) {
      setWatingText("");
      setWithdrawLoading(false);
      dispatch(showMessageBar(MESSAGE_BAR_TYPES.ERROR, err));
    }
  };

  const isDisabled = () => {
    switch (active) {
      case 2:
        if (!cryptoCurrency) {
          return true;
        }
        return false;
      case 3:
        if (widthrawLoading) {
          return widthrawLoading;
        }
        if (!address) {
          return true;
        }
        return !withdrawEnabled;
      default:
        return true;
    }
  };

  const validateWithdraw = () => {
    // eslint-disable-next-line eqeqeq
    if (user && user.kycStatus && user.kycStatus == 3) {
      setShowKytBlocked(true);
      return false;
    }
    // eslint-disable-next-line eqeqeq
    if (user && user.kycStatus && !isKycVerified(user)
    ) {
      setShowKyt(true);
      return false;
    }

    return true;
  };
  const confirmAction = () => {
    if (!service?.travelRule) {
      setConfirm(true);
    } else {
      logEvent({
        current: EVENTS.WITHDRAWAL.CRYPTO_SELECTION,
        activity: ACTIVITY_DETAIL.WITHDRAWAL.CRYPTO_SELECTION,
        meta: {
          data: {
            address: address,
            pathname: location.pathname,
            source: ACTIVITY_META.WITHDRAWAL.CONFIRM_ADDRESS,
          },
        },
      });
      setActive(active + 1);
    }
  }
  const updateOwnershipFormData = (data) => {
    ownershipFormData.current = data;
  }

  if (active === 2 && !currencies?.length) {
    return <AppScreenLoader />;
  }
  if (active === 2 && currencies?.length) {
    return (
      <Paper
        sx={{
          backgroundColor: "transparent",
          boxShadow: "none",
          // minHeight: [1, 2].includes(active) ? "75vh" : "24vh",
          paddingTop: 1,
        }}
      >
        <List sx={{ minHeight: `50vh`, maxHeight: `50vh`, overflowY: "auto" }}>
          {currencies &&
            currencies.map((val, index) => (
              <ListItem
                key={val.id}
                onClick={() => handleCurrencySelect(val)}
                style={cryptoCurrency === val.id ? styles.selected : {}}
              >
                <ListItemAvatar>
                  <Avatar>
                    <img src={getLogo(val.currency)} alt="icon" />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={val?.payoutCurrency?.currency?.fullTitle}
                  secondary={val.currency}
                />
                <ListItemSecondaryAction sx={{ minWidth: "100px" }}>
                  <Typography fontSize={12}>{t("network")}</Typography>
                  <Typography fontSize={14}>
                    {val?.networkFullTitle?.toUpperCase() || " --- "}
                  </Typography>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
        </List>
      </Paper>
    );
  }
  if (active === 3) {
    return (
      <Paper
        sx={{
          backgroundColor: "transparent",
          boxShadow: "none",
          // minHeight: [1, 2].includes(active) ? "75vh" : "24vh",
        }}
      >
        <AppDialog
          show={qrcodeReader}
          onChangeShow={setqrcodeReader}
          fullScreen
          bgColor={"#000000"}
        >
          <QrCodeScanner setQrData={setQrData} />
        </AppDialog>
        <AppDialogHalfScreen
          show={confirm}
          setShow={handleConfirmation}
          title={t("confirmWalletAddress")}
          subtitle={t("confirmWalletAddressSub")}
          note={t("confirmWalletAddressNote")}
          component={
            <Box width={"100%"}>
              <Typography fontSize={14}>{t("walletaddress")}</Typography>
              <Typography
                padding={1}
                border="1px solid #D4D4D8"
                borderRadius={1}
                fontSize={14}
                sx={{ overflowWrap: "anywhere" }}
              >
                {address}
              </Typography>
              <Box
                display={"flex"}
                flexDirection={"row"}
                marginTop={4}
                justifyContent="space-between"
                width={"100%"}
              >
                <Typography
                  fontSize={14}
                  fontWeight={700}
                  fontFamily={"Manrope"}
                >
                  {t("Coin")}: {cryptoCurrency}
                </Typography>
                <Typography
                  fontSize={14}
                  fontWeight={700}
                  fontFamily={"Manrope"}
                  textTransform={"capitalize"}
                >
                  {t("network")}: {network}
                </Typography>
              </Box>
              <Box
                display={"flex"}
                flexDirection={"row"}
                marginTop={1}
                justifyContent="space-between"
                width={"100%"}
              >
                <AppButton
                  title={t("Change")}
                  buttontheme={"light"}
                  onClick={handleTransferChange}
                  sx={{ width: 100, marginLeft: 5 }}
                ></AppButton>
                <AppButton
                  title={t("Confirm")}
                  buttontheme={"success"}
                  onClick={handleConfirm}
                  sx={{ maxWidth: 150, marginRight: 5 }}
                ></AppButton>
              </Box>
            </Box>
          }
        />
        <Typography
          color={"#D4D4D8"}
          fontSize={16}
          textAlign="center"
          paddingTop={1}
          paddingBottom={1}
        >
          {t("add.wallet")}
        </Typography>
        {/* <FormControl variant="filled" fullWidth > */}
        <OutlinedInput
          fullWidth
          type="text"
          sx={{
            fontSize: 18,
            padding: "10px 10px",
            marginTop: 1,
            ".MuiOutlinedInput-notchedOutline": {
              display: "none",
            },
          }}
          autoComplete={"off"}
          value={address}
          onChange={handleManualAddressChange}
          placeholder={t("recurring.enterwalletaddress")}
          onFocus={(ev) => handleAddressInput(ev)}
          error={!!errors.address}
          endAdornment={
            <InputAdornment position="end">
              <AppToolTip title={t("ScanQR")} arrow enterTouchDelay={0}>
                <IconButton edge="end" onClick={() => openQrScanner({
                    onScanned: setQrData,
                    onUseWeb: () => setqrcodeReader(true),
                    onError: (msg) => dispatch(showMessageBar(MESSAGE_BAR_TYPES.ERROR, msg)),
                  })} aria-label="tracker"
                  aria-describedby="qr_code_scanner">
                  <QrCode sx={{ color: "#F8FAFF", width: 40, height: 40 }} aria-label="tracker"
                    aria-describedby="qr_code_scanner" />
                </IconButton>
              </AppToolTip>
            </InputAdornment>
          }
          label="Address"
        />
        <Typography
          fontSize={14}
          fontWeight={700}
          paddingTop={1}
          paddingBottom={1}
          textTransform="capitalize"
          color={"#DC2626"}
          textAlign={"left"}
        >
          {!!errors.address && errors.address}
        </Typography>
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent={"space-between"}
        >
          <Typography fontSize={13} color="#D4D4D8" fontWeight={700}>
            <Checkbox checked={saveWallet} onChange={handleSaveWallet} name="save wallet" />{" "}
            {t("rememberWallet")}
          </Typography>
          <Link
            href={config.ONBOARDING_GUIDE_LINK + "/how-to-create-wallet"}
            target="_blank"
            fontFamily={"Manrope"}
            fontSize={13}
          >
            {t("howtocreatewallet")}
          </Link>
        </Box>
        <br />
        <Box>
          {withdrawData && (
            <Box
              sx={{
                color: "#F8FAFF",
              }}
            >
              <Typography
                fontSize={14}
                color="#A1A1AA"
                fontWeight={400}
                textAlign={"left"}
              >
                {t("Summary")}:
              </Typography>
              <Divider />
              <Grid container sx={{ color: "#D6E3F0", margin: 0 }}>
                <Grid item xs={6}>
                  <Typography
                    fontFamily={"Manrope"}
                    fontSize={14}
                    fontWeight={400}
                    textAlign="left"
                    textTransform="capitalize"
                    color="#D4D4D8"
                  >
                    {t("Amount Requested")}:
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    fontFamily={"Manrope"}
                    fontSize={14}
                    fontWeight={400}
                    textAlign="right"
                    textTransform="capitalize"
                    color="#D4D4D8"
                  >
                    {` ${formatNumber(amount)} ${currency}`}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    fontFamily={"Manrope"}
                    fontSize={14}
                    textAlign="left"
                    fontWeight={400}
                    textTransform="capitalize"
                    color="#D4D4D8"
                  >
                    {t("Currency requested")}:
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    fontFamily={"Manrope"}
                    fontSize={14}
                    textAlign="right"
                    textTransform="uppercase"
                    fontWeight={400}
                    color="#D4D4D8"
                  >
                    {cryptoCurrency} ({network?.toUpperCase()})
                  </Typography>
                </Grid>

                {!!feeStructure?.feeEnabled && <><Grid item xs={6}>
                  <Typography
                    fontFamily={"Manrope"}
                    fontSize={14}
                    textAlign="left"
                    fontWeight={400}
                    textTransform="capitalize"
                    color="#D4D4D8"
                  >
                    {t("processing-fee")}:
                  </Typography>
                </Grid>
                  <Grid item xs={6}>
                    <Typography
                      fontFamily={"Manrope"}
                      fontSize={14}
                      textAlign="right"
                      textTransform="uppercase"
                      fontWeight={400}
                      color="#D4D4D8"
                    >
                      {feeStructure?.fee ? `${feeStructure?.fee} ` : "0"} {currency}{" "}
                      {parseFloat(feeStructure?.feePercent.toString())
                        ? `+ ${feeStructure?.feePercent}%`
                        : ""}{" "}
                    </Typography>
                  </Grid> </>}
                <Grid item xs={12}>
                  <Divider />
                </Grid>
                <Grid
                  item
                  xs={6}
                  fontSize={14}
                  textTransform="capitalize"
                  color="#D4D4D8"
                >
                  <Typography
                    fontFamily={"Manrope"}
                    fontSize={14}
                    textAlign="left"
                    textTransform="capitalize"
                    fontWeight={400}
                    color="#D4D4D8"
                  >
                    {t("Amount To Be Sent")}:

                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={6}
                  textAlign="right"
                  fontSize={14}
                  textTransform="capitalize"
                  color="#D4D4D8"
                >
                  <Typography
                    fontFamily={"Manrope"}
                    fontSize={14}
                    textAlign="right"
                    textTransform="uppercase"
                    fontWeight={400}
                    color="#D4D4D8"
                  >
                    {formatNumber(
                      Number(amount) -
                      Number(feeStructure?.fee || "0") -
                      Number(feeStructure?.localFeePercent  || "0")
                    )}
                    &nbsp;
                    {currency}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={6}
                  fontSize={14}
                  textTransform="capitalize"
                  color="#D4D4D8"
                >
                  <Typography
                    fontFamily={"Manrope"}
                    fontSize={14}
                    textAlign="left"
                    textTransform="capitalize"
                    fontWeight={400}
                    color="#D4D4D8"
                  >
                    {t('Network fees')}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={6}
                  textAlign="right"
                  fontSize={14}
                  textTransform="capitalize"
                  color="#D4D4D8"
                >
                  <Typography
                    fontFamily={"Manrope"}
                    fontSize={14}
                    textAlign="right"
                    textTransform="uppercase"
                    fontWeight={400}
                    color="#D4D4D8"
                  >
                    {withdrawData?.localNetworkFee
                      ? `${withdrawData?.localNetworkFee || 0} ${currency}`
                      : "- - -"}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    fontFamily={"Manrope"}
                    fontSize={14}
                    textAlign="left"
                    textTransform="capitalize"
                    fontWeight={400}
                    color="#D4D4D8"
                  >
                    {t("exchangeRate")}:
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    fontFamily={"Manrope"}
                    fontSize={14}
                    textAlign="right"
                    textTransform="uppercase"
                    fontWeight={400}
                    color="#D4D4D8"
                  >
                    1 {cryptoCurrency} ={" "}
                    {formatCryptoDecimals(exchangeRate)} {currency}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    fontFamily={"Manrope"}
                    fontSize={14}
                    textAlign="left"
                    textTransform="capitalize"
                    fontWeight={400}
                    color="#D4D4D8"
                  >
                    {t("AmountReceived")}:
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Box
                    display={"flex"}
                    flexDirection={"row"}
                    alignItems={"center"}
                    justifyContent={"flex-end"}
                  >
                    <Typography
                      fontFamily={"Manrope"}
                      fontSize={14}
                      textAlign="right"
                      textTransform="uppercase"
                      fontWeight={400}
                      color="#D4D4D8"
                    >
                      {withdrawData?.payoutAmountCrypto ? `${formatCryptoDecimals(
                        withdrawData.payoutAmountCrypto
                      )} ${cryptoCurrency}` : '---'}
                    </Typography>
                    &nbsp;&nbsp;
                    {withdrawData?.payoutAmountCrypto && (
                      <AppToolTip
                        title={t("approxDisclaimer")}
                        arrow
                        enterTouchDelay={0}
                      >
                        <Box
                          display={"flex"}
                          alignItems={"center"}
                          sx={{ cursor: "pointer" }}
                        >
                          <InfoOutlined />
                        </Box>
                      </AppToolTip>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Box>
          )}
        </Box>

        {waitingText && (
          <Box
            display={"flex"}
            flexDirection="row"
            alignItems={"center"}
            marginTop={2}
            sx={{
              display: "flex",
              alignItems: "center",
              marginBottom: 2,
            }}
          >
            <AppLoader
              title={waitingText}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
              fontSize={16}
            />
          </Box>
        )}

        <Button
          variant="contained"
          size="large"
          color="primary"
          disabled={isDisabled()}
          sx={{
            color: "#041939",
            marginTop: 1,
            fontSize: 16,
            width: "100%",
            textTransform: "capitalize",
            borderRadius: "8px",
            ":disabled": { backgroundColor: "#0088F5", opacity: 0.4 },
          }}
          onClick={confirmAction}
        >
          {service?.travelRule ? t("loginPage.continue") : t("transfer")}
        </Button>

        <Box marginTop={1}>
          <Typography
            variant="subtitle1"
            color={"#D4D4D8"}
            textAlign={"left"}
            fontSize={12}
            lineHeight={1.5}
          >
            <ol style={{ paddingLeft: 12 }}>
              <li>{t("transfer.disclaimer1")}</li>
              <li>{t("transfer.disclaimer2")}</li>
            </ol>
          </Typography>
        </Box>
      </Paper>
    );
  }
  if (active === 4) {
    return (
      <ConfirmAddressOwnership
        address={address}
        network={network}
        cryptoCurrency={cryptoCurrency}
        handleConfirm={handleConfirm}
        handleTransferChange={handleTransferChange}
        updateOwnershipFormData={updateOwnershipFormData}
      />
    );
  }

  return <></>;
}

CryptoPayment.propTypes = {
  amount: PropTypes.any,
  setActive: PropTypes.func,
  active: PropTypes.number,
  setShowKytBlocked: PropTypes.func,
  setShowKyt: PropTypes.func,
};
